import { TApiDataStateSlice } from "@redux/store.types";

export const $BoxCountModuleName = "boxCount";

type TBoxCounterSubState = {
    count: number;
}

export type TBoxCounterState = {
    [key: string]: TApiDataStateSlice<TBoxCounterSubState>;
};
